module.exports = __webpack_public_path__ + "static/MaraLogo-16c44abf15d29f73314fc6ac93496515.png";